import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { assetsPropValidation } from '../utils/imagePropValidation';
import { responsiveImage, toVw } from '../utils/styles';
import { CONTAINER_WIDTH } from '../constants';

const Styled = styled.div`
  position: relative;

  ${props =>
    props.ratio &&
    !props.noRatio &&
    css`
      padding-bottom: ${(1 / props.ratio) * 100}%;
    `};
`;

const Image = styled.img`
  ${responsiveImage};
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

class ResponsiveImage extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    sizeContainer: PropTypes.bool,
    sizes: PropTypes.arrayOf(PropTypes.string),
    assets: assetsPropValidation.isRequired,
    alt: PropTypes.string,
    imgRef: PropTypes.func,
    noLazy: PropTypes.bool,
    onLoad: PropTypes.func,
    ratio: PropTypes.number.isRequired,
    noRatio: PropTypes.bool,
  };

  state = {};

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.assets === prevState.assets) {
      return;
    }

    const { assets, sizeContainer, sizes, ...rest } = nextProps;

    const srcSet = assets.map(item => `${item.path}${item.width ? ` ${item.width}w` : ''}`).join(', ');

    let htmlSizes;
    if (sizeContainer) {
      htmlSizes = `${toVw(CONTAINER_WIDTH)}`;
    } else if (sizes) {
      htmlSizes = sizes.join(', ');
    }

    return {
      srcSet,
      sizes: htmlSizes,
      ...rest,
    };
  }

  render() {
    const { imgRef, onLoad, ratio, ...rest } = this.props;
    return (
      <Styled ratio={ratio} {...rest}>
        <Image {...this.state} onLoad={onLoad} innerRef={imgRef ? imgRef : null} ratio={ratio} />
      </Styled>
    );
  }
}

export default ResponsiveImage;



// WEBPACK FOOTER //
// ./src/components/ResponsiveImage.js